import { html } from 'htm/preact'
import { useState } from 'preact/hooks'

export default function CategorySection({ category, count, total, onEdit, onDelete, children }) {
  const key = category || '__uncategorized__'
  const storageKey = `mc-cat-${key}`
  const saved = localStorage.getItem(storageKey)
  const [isCollapsed, setIsCollapsed] = useState(saved === '1')

  function toggle() {
    const next = !isCollapsed
    setIsCollapsed(next)
    localStorage.setItem(storageKey, next ? '1' : '0')
  }

  return html`
    <section class="cat-section">
      <header class="cat-header" onClick=${toggle}>
        <span class="cat-header__chevron">${isCollapsed ? '►' : '▼'}</span>
        <h3 class="cat-header__name">${category || 'Uncategorized'}</h3>
        <span class="cat-header__meta">${count} · ${total}</span>
        ${(onEdit || onDelete) && html`
          <span class="cat-header__actions" onClick=${e => e.stopPropagation()}>
            ${onEdit && html`
              <button type="button" class="cat-action-btn" aria-label="Rename category" onClick=${onEdit}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                  <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                  <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                </svg>
              </button>
            `}
            ${onDelete && html`
              <button type="button" class="cat-action-btn cat-action-btn--danger" aria-label="Delete category" onClick=${onDelete}>
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2">
                  <polyline points="3 6 5 6 21 6"/>
                  <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/>
                  <path d="M10 11v6M14 11v6"/>
                  <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/>
                </svg>
              </button>
            `}
          </span>
        `}
      </header>
      ${!isCollapsed && html`<div class="cat-body">${children}</div>`}
    </section>
  `
}
